<div [ngClass]="{ gateWayLab: gateWayLab }">
  @if (showInIframe) {
    <div>
      @if (appUrl) {
        <div class="iframe-wrapper">
          @if (!setSize) {
            <iframe
              [height]="fixedHeight"
              [src]="saveAppUrl"
              allowfullscreen=""
              class="height-sized-iframe"
              loading="lazy"
              sandbox="allow-forms allow-scripts allow-same-origin allow-modals allow-orientation-lock"
              title="client content"
            ></iframe>
          }
          @if (setSize) {
            <iframe
              [height]="height"
              [src]="saveAppUrl"
              [width]="width"
              allowfullscreen=""
              class="sized-iframe"
              loading="lazy"
              sandbox="allow-forms allow-scripts allow-same-origin allow-modals allow-orientation-lock"
              title="client content"
            ></iframe>
          }
        </div>
      }
      @if (originalLabUrl) {
        <div class="credits">
          <div>
            @switch (labProvider) {
              @case ('duffy') {
                <span> {{ i18nKey + '.author' | translate }}: Andrew Duffy. </span>
              }
              @case ('walterFendt') {
                <span class="walter-fendt">
                  <span> {{ i18nKey + '.author' | translate }}: Walter Fendt </span>
                  <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank">
                    <img alt="CC-BY-NC-SA" class="license-image" src="assets/shared-images/licenses/by-nc-sa.svg" />
                  </a>
                </span>
              }
              @case ('academo') {
                <span>
                  © Academo.org 2024. {{ i18nKey + '.sourceCodeAvailable' | translate }}
                  <a href="https://github.com/edwardball/academo.org" target="_blank">GitHub.com</a>
                </span>
              }
              @case ('galileoAndEinstein') {
                <span>
                  {{ i18nKey + '.author' | translate }}:
                  <a href="https://galileo.phys.virginia.edu/~mf1i/home.html" target="_blank">Michael Fowler</a>.
                </span>
              }
            }
          </div>
          <div>
            {{ i18nKey + '.obtainedFrom' | translate }}:
            <a [href]="originalLabUrl" target="_blank">{{ originalLabUrl }}</a>
          </div>
        </div>
      }
    </div>
  }
  @if (!showInIframe && appUrl) {
    <div class="open-in-new-tab">
      <div>
        {{ i18nKey + '.labInNewTabMessage' | translate }}
      </div>
      <a [href]="saveAppUrl" mat-stroked-button target="_blank">
        <mat-icon>open_in_new</mat-icon>
        <span>{{ content?.title }}</span>
      </a>
    </div>
  }
</div>
